<!-- Footer -->
    <div class="footer-left">© 2022 - {{currentYear}} All Rights Reserved.</div>
    <div class="footer-right">
        Powered by  <img class="mobileLogo" src="assets/images/elogitrax-logo2.png" />
    </div>
<!-- Footer -->